export const siteUrl = "https://yoybuy.wtf";

export const logoUrl =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fcef7be7473f7.jpeg";

export const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": siteUrl + "/#website",
  url: siteUrl,
  name: "YOYBUY.WTF",
  inLanguage: "ru",
  description:
    "YOYBUY Spreadsheet — лучшая система покупок товаров из Китая. Обувь, одежда, аксессуары, парфюмерия с экономией до 40%. Доставка по всему миру.",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: siteUrl + "/search?q={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": siteUrl + "/#organization",
  name: "YOYBUY",
  url: siteUrl,
  logo: {
    "@type": "ImageObject",
    url: logoUrl,
    width: 192,
    height: 192,
  },
  sameAs: ["https://yoybuy.wtf"],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    availableLanguage: ["Russian", "English"],
  },
};

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export interface ArticleSchemaData {
  slug: string;
  title: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
  category: string;
}

export const articleSchema = (data: ArticleSchemaData) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "@id": siteUrl + "/article/" + data.slug + "/#article",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": siteUrl + "/article/" + data.slug,
  },
  headline: data.title,
  description: data.description,
  image: {
    "@type": "ImageObject",
    url: data.image,
    width: 800,
    height: 500,
  },
  datePublished: data.datePublished,
  dateModified: data.dateModified,
  author: {
    "@type": "Organization",
    name: data.authorName,
    url: siteUrl,
  },
  publisher: {
    "@type": "Organization",
    "@id": siteUrl + "/#organization",
    name: "YOYBUY",
    logo: {
      "@type": "ImageObject",
      url: logoUrl,
    },
  },
  inLanguage: "ru",
  isAccessibleForFree: true,
});

export const faqSchema = (faqItems: { question: string; answer: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});